var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderTestcaseCloudStudio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.848 5.246c-.11-1.586-1.422-2.871-3.036-2.871a2.33 2.33 0 0 0-.628.082C10.309 1.363 8.969.625 7.438.625a4.839 4.839 0 0 0-4.731 3.828A4.377 4.377 0 0 0 0 8.5a4.353 4.353 0 0 0 4.375 4.375h9.188c2.16 0 3.937-1.75 3.937-3.938 0-1.667-1.094-3.144-2.652-3.69zm-1.286 6.316H4.376A3.057 3.057 0 0 1 1.312 8.5a3.015 3.015 0 0 1 2.625-3.008v-.054c0-1.915 1.56-3.5 3.5-3.5 1.45 0 2.708.902 3.227 2.187.3-.273.711-.438 1.149-.438.957 0 1.75.793 1.75 1.75 0 .329-.11.63-.247.903.082 0 .164-.027.246-.027a2.626 2.626 0 0 1 0 5.25z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTestcaseCloudStudio);
export default __webpack_public_path__ + "static/media/folder-testcase-cloud-studio.de3dd48e22245f535db78d98cf0b95bc.svg";
export { ForwardRef as ReactComponent };